module.exports = __webpack_public_path__ + "static/media/font_bold.2a2fd49a.woff2";